/** biome-ignore-all lint/a11y/noStaticElementInteractions: <explanation> */
import { show } from "@ebay/nice-modal-react";
import { canv } from "@/canv/global";
import { pasteEmbed } from "@/canvasController/helpers";
import { eventEmitter } from "@/eventEmitter";
import { CreateEmbedModal } from "@/interface/ui/modals";
import { Tooltip } from "@/interface/ui/Tooltip";
import { VStack } from "@/shared/ui/Stack";
import type { Tool, ToolName } from "@/tools/types";
import InfoSvg from "../../../icons/Info.svg?react";
import { getMoreToolsNames } from "../utils";
import styles from "./MoreWindow.module.css";

export const MoreWindow = () => {
    const toolsNames = getMoreToolsNames();

    const handleSelect = (tool: Tool) => {
        if (tool.name === "stickersTool") {
            canv.toolBox.TryGetToolByName("stickersTool").select();
        } else if (tool.name === "embedTool") {
            show(CreateEmbedModal).then((embedUrl) => {
                if (!embedUrl) {
                    return;
                }
                pasteEmbed(embedUrl as string);
            });
        } else {
            canv.toolBox.switchToByName(tool.name as ToolName);
        }

        eventEmitter.dispatch("moreTool.visibility", { isVisible: false });
    };

    return (
        <div className={styles.moreWindow}>
            <VStack align="start" className={styles.moreWindowContent}>
                {toolsNames.map((toolName) => {
                    const tool = canv.toolBox.TryGetToolByName(toolName);

                    return (
                        <div
                            key={toolName}
                            className={styles.moreWindowContentItem}
                            onClick={() => handleSelect(tool)}
                        >
                            <div
                                className={styles.moreWindowContentItemIcon}
                                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                                dangerouslySetInnerHTML={{ __html: tool.getToolView() }}
                            />
                            <div className={styles.moreWindowContentItemTitle}>
                                {tool.getToolTipName()}
                            </div>
                            {tool.getToolName() === "mediaTool" && (
                                <Tooltip content="JPEG, PNG, PDF до 30 Мб" placement="right-start">
                                    <div className={styles.moreWindowContentItemInfo}>
                                        <InfoSvg />
                                    </div>
                                </Tooltip>
                            )}
                        </div>
                    );
                })}
            </VStack>
        </div>
    );
};
